var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page checkout" },
    [
      _c("div", { staticClass: "onlyForHighScreens" }, [_vm._v(" ")]),
      _c("v-container", [
        _c(
          "h1",
          {
            staticClass: "text-center mt-3",
            staticStyle: { "margin-bottom": "2px" },
          },
          [_c("span", [_vm._v("Bestellung abschließen")])]
        ),
      ]),
      _c("div", { staticClass: "text-center" }, [
        _c("h4", { staticClass: "mb-6" }, [
          _vm._v("Gesamtsumme: "),
          _c("span", { staticClass: "textFont" }, [
            _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
          ]),
        ]),
      ]),
      _c(
        "v-container",
        { staticClass: "ccontainer", attrs: { "grid-list-md": "" } },
        [
          _c(
            "div",
            { staticClass: "kioskCheckoutContainer" },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "vvd orderform",
                  attrs: { vertical: "", id: "stepper" },
                  model: {
                    value: _vm.currentStep,
                    callback: function ($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep",
                  },
                },
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: { complete: _vm.currentStep > 1, step: "1" },
                      nativeOn: {
                        "&click": function ($event) {
                          _vm.currentStep = 1
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "nice-title titleFont" }, [
                        _vm._v(
                          "Optional kannst du deinen Namen für die Abholung eingeben"
                        ),
                      ]),
                    ]
                  ),
                  _c("v-stepper-content", { attrs: { step: "1" } }, [
                    _vm.usecase.length > 0
                      ? _c("div", { attrs: { id: "checkData" } }, [
                          _c(
                            "div",
                            { staticClass: "bestelldaten pt-1" },
                            [
                              _c(
                                "v-form",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showForm,
                                      expression: "showForm",
                                    },
                                  ],
                                  ref: "inhouseMpDataForm",
                                  attrs: { "lazy-validation": "" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "prelative" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          value: _vm.name,
                                          label: "Dein Name",
                                          rules: _vm.nameRules,
                                          placeholder: "Dein Name",
                                          illed: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          input: _vm.updateName,
                                          focus: _vm.nameFocus,
                                          blur: _vm.unhideToolbar,
                                        },
                                      }),
                                      _vm.name
                                        ? _c(
                                            "div",
                                            { staticClass: "absClear" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "myBlack",
                                                  on: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      _vm.name = ""
                                                    },
                                                  },
                                                },
                                                [_vm._v("mdi-close ")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.$store.state.enableOrderNote
                                    ? [
                                        _c("h4", { staticClass: "mt-4" }, [
                                          _vm._v("Hinweise zur Bestellung"),
                                        ]),
                                        _c("v-text-field", {
                                          staticClass: "nolabel",
                                          attrs: {
                                            outlined: "",
                                            "hide-details": "",
                                            clearable: "",
                                            illed: "",
                                          },
                                          on: { focus: _vm.hinweisFocus },
                                          model: {
                                            value: _vm.note,
                                            callback: function ($$v) {
                                              _vm.note = $$v
                                            },
                                            expression: "note",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mt-7" },
                            [
                              _vm.step1Error && _vm.initialTry
                                ? _c(
                                    "div",
                                    { staticClass: "error--text mt-2 mb-4" },
                                    [_vm._v(_vm._s(_vm.step1Error))]
                                  )
                                : _vm._e(),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "pulsing btn-df weiter",
                                  attrs: { disabled: !_vm.step1Ok },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.finishStep1.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Weiter ")]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "v-stepper-step",
                    {
                      attrs: { complete: _vm.currentStep > 2, step: "2" },
                      nativeOn: {
                        "&click": function ($event) {
                          _vm.currentStep = 2
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "nice-title titleFont" }, [
                        _vm._v("Trinkgeld geben"),
                      ]),
                    ]
                  ),
                  _c("v-stepper-content", { attrs: { step: "2" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "pl-5 mt-2 flex-container align-center",
                        staticStyle: {
                          "font-size": "1.2em",
                          "row-gap": "10px",
                        },
                      },
                      [
                        _c("div", { staticClass: "bold" }, [
                          _vm._v(
                            _vm._s(_vm._f("price")(_vm.$store.getters.payerSum))
                          ),
                        ]),
                        _c("div", { staticClass: "ml-2 mr-2" }, [_vm._v("+")]),
                        _c("v-text-field", {
                          staticClass: "inputTipAmount",
                          class: {
                            tipInputAnimation: _vm.showTipInputAnimation,
                          },
                          attrs: {
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            type: "number",
                          },
                          model: {
                            value: _vm.inputTipAmount,
                            callback: function ($$v) {
                              _vm.inputTipAmount = $$v
                            },
                            expression: "inputTipAmount",
                          },
                        }),
                        _c("div", { staticClass: "ml-2 bold" }, [_vm._v("€")]),
                        _c("div", { staticClass: "ml-2 bold hidden-xs-only" }, [
                          _vm._v("Trinkgeld"),
                        ]),
                        _c("div", { staticClass: "ml-2 mr-2" }, [_vm._v("=")]),
                        _c("div", { staticClass: "bold mr-2" }, [
                          _vm._v(_vm._s(_vm._f("price")(_vm.total))),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "flex-container tipContainer" }, [
                      _c(
                        "div",
                        {
                          staticClass: "pointer mar-15 mt-3",
                          on: { click: _vm.clickCustomTip },
                        },
                        [
                          _c("div", { staticClass: "prelative" }, [
                            _c(
                              "div",
                              {
                                staticClass: "tipBox pointer superCenter",
                                class:
                                  _vm.tipType === "none" && _vm.customTipActive
                                    ? "tipBoxSelected"
                                    : "",
                              },
                              [
                                _c("div", { staticClass: "text-center bold" }, [
                                  _c("div", [_vm._v("Eigener")]),
                                  _c("div", [_vm._v("Betrag")]),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pointer mar-15 mt-3",
                          on: { click: _vm.clickZeroTip },
                        },
                        [
                          _c("div", { staticClass: "prelative" }, [
                            _c(
                              "div",
                              {
                                staticClass: "tipBox pointer superCenter",
                                class:
                                  _vm.tipType === "none" && !_vm.customTipActive
                                    ? "tipBoxSelected"
                                    : "",
                              },
                              [
                                _c("div", { staticClass: "text-center bold" }, [
                                  _c("div", [_vm._v("Ohne")]),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pointer mar-15 mt-3",
                          on: {
                            click: function ($event) {
                              return _vm.updateTipPercent("a")
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "pointer tipBox superCenter",
                              class:
                                _vm.tipType !== "none" &&
                                _vm.tipPercent === _vm.tipConfig["a"] &&
                                _vm.calcTipAmount("a") === _vm.inputTipAmount
                                  ? "tipBoxSelected"
                                  : "",
                            },
                            [
                              _c("div", { staticClass: "text-center" }, [
                                _c("div", { staticClass: "tipAmount bold" }, [
                                  _vm._v(_vm._s(_vm.tipConfig["a"]) + "%"),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(_vm.calcTipAmount("a"))
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pointer mar-15 mt-3",
                          on: {
                            click: function ($event) {
                              return _vm.updateTipPercent("b")
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "pointer tipBox superCenter",
                              class:
                                _vm.tipType !== "none" &&
                                _vm.tipPercent === _vm.tipConfig["b"] &&
                                _vm.calcTipAmount("b") === _vm.inputTipAmount
                                  ? "tipBoxSelected"
                                  : "",
                            },
                            [
                              _c("div", { staticClass: "text-center" }, [
                                _c("div", { staticClass: "tipAmount bold" }, [
                                  _vm._v(_vm._s(_vm.tipConfig["b"]) + "%"),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(_vm.calcTipAmount("b"))
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pointer mar-15 mt-3",
                          on: {
                            click: function ($event) {
                              return _vm.updateTipPercent("c")
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "pointer tipBox superCenter",
                              class:
                                _vm.tipType !== "none" &&
                                _vm.tipPercent === _vm.tipConfig["c"] &&
                                _vm.calcTipAmount("c") === _vm.inputTipAmount
                                  ? "tipBoxSelected"
                                  : "",
                            },
                            [
                              _c("div", { staticClass: "text-center" }, [
                                _c("div", { staticClass: "tipAmount bold" }, [
                                  _vm._v(_vm._s(_vm.tipConfig["c"]) + "%"),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(_vm.calcTipAmount("c"))
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm.total % 1 !== 0
                        ? _c(
                            "div",
                            {
                              staticClass: "pointer mar-15 mt-3",
                              on: { click: _vm.roundUpTip },
                            },
                            [
                              _c("div", { staticClass: "prelative" }, [
                                _c(
                                  "div",
                                  { staticClass: "tipBox pointer superCenter" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-center bold" },
                                      [
                                        _c("div", [
                                          _vm._v("Auf-"),
                                          _c("br"),
                                          _vm._v("runden"),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-7" },
                      [
                        _vm.step2Error && _vm.initialTry
                          ? _c(
                              "div",
                              { staticClass: "error--text mt-2 mb-4" },
                              [_vm._v(_vm._s(_vm.step2Error))]
                            )
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            staticClass: "pulsing btn-df weiter",
                            attrs: { disabled: !_vm.step2Ok },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.finishStep2.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v(" Weiter ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-df weiter grayBtn",
                            nativeOn: {
                              "&click": function ($event) {
                                _vm.currentStep = 1
                              },
                            },
                          },
                          [_vm._v(" Zurück ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.currentStep === 2
            ? _c("div", { staticClass: "mt-4 text-center" }, [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "mt-3 checkoutButtonStyle",
                      on: { click: _vm.finishStep2 },
                    },
                    [_vm._v(" Bestätige deine Bestellung ")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-btn",
            {
              staticClass: "text-none btn-mini",
              staticStyle: { "margin-top": "25px" },
              on: { click: _vm.cancelOrder },
            },
            [_vm._v(" Bestellung abbrechen ")]
          ),
        ],
        1
      ),
      _c("ZvtDialog", {
        attrs: {
          total: _vm.total,
          terminalInstructions: _vm.terminalInstructions,
          dialog: _vm.showZvtDialog,
        },
        on: { close: _vm.closeZvtDialog },
      }),
      _vm.showKeyboard
        ? _c("div", { staticClass: "fixedVirtualKeyboard" }, [
            _c(
              "div",
              { staticClass: "superCenter" },
              [
                _c("VirtualKeyboard", {
                  attrs: { label: _vm.keyboardLabel },
                  on: {
                    enter: _vm.keyboardEnter,
                    close: function ($event) {
                      _vm.showKeyboard = false
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }